import React, { Children, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

const Confirm = ({ title, bodyContent, confirmText, onConfirm, children }) => {
    const [show, setShow] = useState(false)
    
    const onClose = () => setShow(false)
    
    return (
        <>
        <span onClick={() => setShow(true)}>
        {children}
        </span>
        <Modal show={show} onHide={onClose}>
            <Modal.Header>
                <Modal.Title>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {bodyContent}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => { onConfirm(); onClose() }}>
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    )
}

export default Confirm
